module.exports = __webpack_public_path__ + "static/media/icons_Bilan Gériatrie.faf548ea.svg";